import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface VendorInformationReduxSliceState {
    id?: number;
    name?: string;
    code?: string;
    email?: string;
    phone?: string;
    paymentTermsCode?: string;
    statusId?: number;
    statusName?: string;
}


type SetVendorInformationPayload = Partial<VendorInformationReduxSliceState>;


const initialState: VendorInformationReduxSliceState = {}

const sliceName = 'vendorInformation';

/**
 * The Redux state, action creators, types and reducers of the Vendor-information slice.
 */
export const VendorInformationReduxSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setVendorInformation: (
            state,
            action: PayloadAction<SetVendorInformationPayload>) => {
            Object
                .keys(action.payload)
                .forEach((key) => {
                    state[key as keyof SetVendorInformationPayload] = action.payload[key as keyof SetVendorInformationPayload] as any;
                });
            return state;
        },
        clearVendorInformation: () => initialState,
    }
});

export default VendorInformationReduxSlice;
